import { render } from "./CoDong.vue?vue&type=template&id=236650c9"
import script from "./CoDong.vue?vue&type=script&lang=js"
export * from "./CoDong.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__